import { createContext } from 'react';
import type { ShareSettingsInternalProviderContextValue } from '../../types';

export const ShareSettingsInternalContext = createContext<ShareSettingsInternalProviderContextValue | null>(null);
